import axiosInstance from '../../../lib/axios';

export const userService = {
  getUsers: async (params = {}) => {
    const response = await axiosInstance.get('/api/v1/admin/users', { params });
    return response.data;
  },
  
  getUser: async (id) => {
    const response = await axiosInstance.get(`/api/v1/admin/users/${id}`);
    return response.data;
  },
  
  createUser: async (data) => {
    const response = await axiosInstance.post('/api/v1/admin/users', data);
    return response.data;
  },
  
  updateUser: async (id, data) => {
    const response = await axiosInstance.put(`/api/v1/admin/users/${id}`, data);
    return response.data;
  },
  
  deleteUser: async (id) => {
    const response = await axiosInstance.delete(`/api/v1/admin/users/${id}`);
    return response.data;
  },
  getAuthUser: async () => {
    const response = await axiosInstance.get('/api/v1/admin/me');
    return response.data;
  },

toggleBlacklist:async (userId, status) => {
  return axiosInstance.put(`/api/v1/admin/users/${userId}/blacklist`, { is_blacklisted: status });
},

resetPassword:async (userId) => {
  return axiosInstance.post(`/api/v1/admin/users/${userId}/reset-password`);
}
};